import { VideoAccountIcon } from './VideoAccountIcon';

/**
 * author: Google
 * id F02BE782-F323-40E5-B245-DF7B6AFB2B15
 * name video-account
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-account.svg
 * tags
 * - Account / User 
 * - Video / Movie 
 */
export const VideoUserIcon = VideoAccountIcon;
export default VideoUserIcon